module.exports = ".table>thead>tr>th {\r\n  border: 1px solid #ccc !important;\r\n}\r\n\r\n.red {\r\n  color: #ED1C24;\r\n}\r\n\r\n.yellow {\r\n  color: #E5BC0E;\r\n}\r\n\r\n.green {\r\n  color: #41B53B;\r\n}\r\n\r\n.upload-history {\r\n  height: 100vh;\r\n  overflow-y: auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/upload-history/upload-history.component.css
// module id = ./src/app/common/upload-history/upload-history.component.css
// module chunks = main